import Highlighter from "react-highlight-words";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { makeStyles } from "tss-react/mui";

import { Typography } from "@mui/material";
import { TextLink } from "@shared/TextLink";
import { CellContext } from "@tanstack/react-table";

import { GroupOverviewData } from "../../GroupPage.utils";

const useStyles = makeStyles()((theme) => ({
    muted: { color: theme.palette.emteria.text.secondary },
    highlightedText: { backgroundColor: theme.palette.emteria.warning },
}));

export const PolicyCell = (props: CellContext<GroupOverviewData, unknown>) => {
    const { t } = useTranslation(["sidepanels"]);
    const { classes } = useStyles();
    const navigate = useNavigate();
    const { policyId, policyName } = props.row.original;
    const globalFilter: string = props.table.getState().globalFilter;

    if (!policyId || !policyName) {
        return (
            <Typography variant="body1" component="span" className={classes.muted}>
                -
            </Typography>
        );
    }

    const showPolicy: React.MouseEventHandler<HTMLElement> = (event) => {
        // The row itself opens the group side panel.
        event.stopPropagation();
        void navigate(`/dashboard/policies?policyId=${policyId}`);
    };

    return (
        <TextLink
            onClick={showPolicy}
            tooltip={t("sidepanels:groupPanel.policyTab.tooltip.showPolicy")}
            truncatedTooltip={policyName}
            sx={{ maxWidth: 200 }}
        >
            <Highlighter
                searchWords={globalFilter ? [globalFilter] : []}
                textToHighlight={policyName}
                autoEscape
                highlightClassName={classes.highlightedText}
            />
        </TextLink>
    );
};
